import { render, staticRenderFns } from "./p-content.vue?vue&type=template&id=5683eeff&scoped=true"
import script from "./p-content.vue?vue&type=script&lang=js"
export * from "./p-content.vue?vue&type=script&lang=js"
import style0 from "./p-content.vue?vue&type=style&index=0&id=5683eeff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5683eeff",
  null
  
)

export default component.exports